import { useFind } from 'api/APIHooks';

export const useReviewReasonOptions = (feeScheduleId, enabled = true) => {
  const { data: reviewReasons } = useFind(
    'service_authorization_review_reasons',
    {
      fee_schedule: feeScheduleId,
    },
    {
      queryConfig: {
        placeholderData: undefined,
        enabled: !!feeScheduleId && enabled,
      },
    },
  );

  return reviewReasons?.data?.data?.map((reviewReason) => ({
    label: reviewReason?.reason,
    value: reviewReason?.id,
  }));
};
